export function MobileNav({ links, onNavigate }) {
  return (
    <div className="md:hidden mt-2 backdrop-blur-md bg-white/95 border border-stone-200/60 rounded-2xl p-4 flex flex-col gap-1 shadow-xl">
      {links.map((l) => (
        <button
          key={l.id}
          data-testid={`nav-mobile-link-${l.id}`}
          onClick={() => onNavigate(l.id)}
          className="text-left text-sm font-medium text-ink py-2.5 px-3 rounded-xl hover:bg-sand transition-colors"
        >
          {l.label}
        </button>
      ))}
      <button
        data-testid="nav-mobile-book-button"
        onClick={() => onNavigate("booking")}
        className="mt-1 rounded-full bg-ink text-alabaster text-sm font-medium px-5 py-3 hover:bg-gold transition-colors"
      >
        Book Appointment
      </button>
    </div>
  );
}
